/* src/app/components/info-programacion-didactica-modal/info-programacion-didactica-modal.component.scss */
.container {
  padding: 30px;
  margin: auto;
}
.container h1 {
  font-weight: 600;
  font-size: 32px;
  margin-top: 0;
}
.container span {
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}
.container ion-button {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  min-height: unset;
  min-width: 140px;
  --border-radius: 10px;
}
.container ion-button::part(native) {
  padding: 14px;
  border-width: 1px;
}
.container .info-div {
  padding: 15px;
  border-radius: 10px;
  background: rgba(67, 192, 246, 0.0509803922);
  border: 2px solid #43c0f6;
}
.container .info-div li {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  color: #0c8ce9;
  text-align: justify;
  flex: 1 1 0;
  font-size: 16px;
}
.container .info-div ion-icon {
  width: 30px;
  height: 30px;
  color: #0c8ce9;
}
.container ion-checkbox {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  width: 100%;
}
.container ion-checkbox::part(label) {
  white-space: unset;
}
@media (max-width: 400px) {
  ion-button,
  li {
    font-size: 14px !important;
    min-width: unset !important;
  }
}
/*# sourceMappingURL=info-programacion-didactica-modal.component-6CUNBMQU.css.map */
